/*eslint max-lines: ["error", 600]*/

/**
 *  Module for monogramming
 */
const WebFont = require('webfontloader');

const Monogram = function (app) {

  const _ = require('lodash');
  const SimpleCYO = require('./simpleCYO')(app);

  /**
   *  Private Properties/Methods
   */
  const configure = app.configure;
  const $container = app.$container;
  let $monogramCanvas;
  let $standardCanvas;

  // if we add showMonogramming=true to the url the canvas will show.
  const showMonogramming = app.mergedParams.showMonogramming;
  const showRuler = app.mergedParams.showRuler;
  const showGrid = app.mergedParams.showGrid;
  const $ = require('jquery');
  let style;
  let absoluteParent;

  /* ==================================================
  =            Define Constants.                     =
  ================================================== */
  const {
    allowedAlias,
    fontid,
    fonts,
    parentAlias,
    uvMap,
    nonMonogramUvMap,
    allowedNonProductAlias
  } = require('./constants');
  const LOADING_CLASS = 'fc-monogramming-display-loading';
  /* =====  End of Define Constants. =============== */

  /* ====================================
  =            Define Utils             =
  ==================================== */
  const utils = require('./utils.js');
  const getAbsoluteParent = utils.getAbsoluteParent;
  const updateView = utils.updateView;
  const clearMonogram = utils.clearMonogram;
  const getInitials = utils.getInitials;
  const getFontColor = utils.getFontColor;
  const getPersonalizationStyle = utils.getPersonalizationStyle;
  /* =====  End of Define Utils  ====== */

  /* =========================================
  =            Monogram Draw Fn.             =
  ========================================= */
  const drawBigMonogram = require('./monogramming.js').drawBigMonogram;
  const drawNonClothingText = require('./monogramming.js').drawNonClothingText;
  /* =====  End of Monogram Draw Fn.  ====== */

  function toggleDisplayLoading(options = {}) {
    const $model = $container.find('.fc-model-container-wrapper');

    if (options.forceRemove) {
      $model.removeClass(LOADING_CLASS);
    } else {
      $model.toggleClass(LOADING_CLASS);
    }
  }

  function getBaseAlias(alias, selectedValue) {
    if (selectedValue.vendorId === 'center_pony') {
      return 'center_chest';
    }
    return parentAlias.find(val => alias.startsWith(val));
  }

  const MONOGRAM_ALIAS_TEST = /_monogram$/;
  function isMonogramAlias(alias) {
    return alias && alias.match(MONOGRAM_ALIAS_TEST);
  }

  /*
   * Takes an alias and then either a string or an array of strings to remove
   * from the alias string
   */
  function stripString(alias, strArr) {
    if (_.isArray(strArr)) {
      _.forEach(strArr, (str) => {
        if (alias.indexOf(str) >= 0) {
          alias = alias.replace(str, '');
        }
      });
    } else {
      if (alias.indexOf(strArr) >= 0) {
        alias = alias.replace(strArr, '');
      }
    }

    return alias;
  }

  /* ----  Main method that gets called to render the non-product text  ---- */
  function updateNonClothingText(change, uvMapType) {
    let alias = change.ca.alias;
    let lineNum;

    if (alias.indexOf('_monogram') >= 0) {
      lineNum = alias.indexOf('_line_');

      if (lineNum >= 0) {
        lineNum = alias.substring(lineNum, alias.length);
      } else {
        lineNum = null;
      }

      alias = alias.substring(0, alias.indexOf('_monogram', ''));
    }

    if (alias.indexOf('_customization_selection') >= 0) {
      alias = alias.replace('_customization_selection', '');
    }

    const absoluteParent = configure.run('getAttribute', { alias });
    const baseAlias = absoluteParent.alias;
    const mergedAlias = baseAlias + (lineNum ? lineNum : '');
    const selectedValue = app.helpers.getSelectedValueByAlias(baseAlias);
    const canvas = (uvMapType === 'standard') ? $standardCanvas[0] : $monogramCanvas[0];
    const ctx = canvas.getContext('2d');
    const $canvas = (uvMapType === 'standard') ? $standardCanvas : $monogramCanvas;

    // Clear the canvas
    ctx.clearRect(0, 0, $canvas.width(), $canvas.height());

    const color = getFontColor(configure, baseAlias);
    let initials = getInitials(configure, baseAlias, lineNum);
    let ugcAlias = mergedAlias + '_ugc';

    if (baseAlias === 'corner') {
      // Get the UGC area from the metadata
      const fabric = app.helpers.getSelectedValueByAlias('fabric');
      const md = app.utils.getMetaData(fabric).ugc;
      ugcAlias = ugcAlias.replace('_ugc', `_${md}`);
    }

    let selectedFontId;
    style = getPersonalizationStyle(configure, absoluteParent.alias);
    if (style.metadata) {
      selectedFontId = app.utils.getMetaData(style).fontid;
    } else if (selectedValue.vendorId === 'center_pony') {
      selectedFontId = 'C050CLA0';
    }
    if (!selectedFontId) {
      return;
    }

    const minLength = (fontid[selectedFontId]) ? fontid[selectedFontId].minLength : null;

    if (minLength) {
      if (
        initials.length > 0 &&
        minLength &&
        initials.length < minLength
      ) {
        initials = '';
      }
    }

    if (uvMapType === 'standard') {
      drawNonClothingText(ctx, {
        text: initials,
        fontid: selectedFontId,
        absoluteParent: mergedAlias,
        color,
        uvMapType,
        app
      });
    } else {
      drawBigMonogram(ctx, {
        initials,
        fontid: selectedFontId,
        color,
        absoluteParent: baseAlias,
        app
      });
    }

    const dataUrl = canvas.toDataURL();

    // Before setting the new value clear the old values
    clearMonogram(configure, ugcAlias);
    if (!$('.' + LOADING_CLASS).length) {
      // Indicate status loading so we can disable the add to cart button.
      app.actions.updateMonogramUGC('loading');
      app.cart.updateAddToCart();
    }

    app.performance.mark('configure:ugc:upload-image');

    if (app.helpers.hasAttribute(ugcAlias)) {
      app.configure.run('setUgcImage', {
        ca: { alias: ugcAlias },
        dataURI: dataUrl,
        onUploadComplete(uploadedImageDetails) {
          app.actions.updateMonogramUGC(encodeURIComponent(uploadedImageDetails.av.clipArt));
          if (app.isFluidEnv() && showMonogramming) {
            console.log('ugc update done', uploadedImageDetails);
          }
        },
        setValue: true
      }, function (err) {
        if (err) {
          console.log('ugc error', err);
        }

        app.performance.mark('configure:ugc:success-callback');
      });
    }
  }

  /* ----------  Main method that gets called to render the text  ---------- */
  function updateText(change) {
    app.performance.mark('configure:ugc:start');

    const alias = change.ca.alias;
    absoluteParent = getAbsoluteParent(configure, change.ca.id);
    const selectedValue = absoluteParent.values.find(val => val.selected);
    const baseAlias = getBaseAlias(alias, selectedValue);
    const canvas = $monogramCanvas[0],
      ctx = canvas.getContext('2d'),
      color = getFontColor(configure, baseAlias);
    let initials = getInitials(configure, baseAlias).toUpperCase();
    let ugcAlias = baseAlias + '_ugc';
    const recipeAlias = configure.run('getRecipe', 'custom', 'alias');
    const aliases = Object.keys(recipeAlias);
    const croppedAlias = baseAlias + '_cropped_ugc';
    if (aliases.includes(croppedAlias)) {
      ugcAlias = croppedAlias;
    }
    // Return if the initials are blank and the monogram text is not being changed
    if (!isMonogramAlias(alias) && initials.length < 1) {
      return;
    }
    let selectedFontId;
    style = getPersonalizationStyle(configure, absoluteParent.alias);
    if (style.metadata) {
      selectedFontId = app.utils.getMetaData(style).fontid;
    } else if (selectedValue.vendorId === 'center_pony') {
      selectedFontId = 'C050CLA0';
    }
    if (!selectedFontId) {
      return;
    }
    if (initials.length > 0 && fontid[selectedFontId].minLength && initials.length < fontid[selectedFontId].minLength) {
      initials = '';
    }
    updateView(app, alias);
    ctx.clearRect(0, 0, 400, 400);
    if (app.isFluidEnv() && showMonogramming) {
      console.log('fontid', selectedFontId);
      console.log('Sizes', fontid[selectedFontId].size);
    }
    drawBigMonogram(ctx, {
      initials,
      fontid: selectedFontId,
      color,
      absoluteParent: baseAlias,
      app
    });


    if (showGrid) {
      app.utils.drawGridOnCtx(ctx, { horizontal: true, vertical: true, separation: showGrid, $monogramCanvas });
    }
    const dataUrl = canvas.toDataURL();
    // Before setting the new value clear the old values
    clearMonogram(configure, ugcAlias);
    if (!$('.' + LOADING_CLASS).length) {
      toggleDisplayLoading();
      // Indicate status loading so we can disable the add to cart button.
      app.actions.updateMonogramUGC('loading');
      app.cart.updateAddToCart();
    }

    app.performance.mark('configure:ugc:upload-image');

    if (app.helpers.hasAttribute(ugcAlias)) {
      app.configure.run('setUgcImage', {
        ca: { alias: ugcAlias },
        dataURI: dataUrl,
        onUploadComplete(uploadedImageDetails) {
          app.actions.updateMonogramUGC(encodeURIComponent(uploadedImageDetails.av.clipArt));
          if (app.isFluidEnv() && showMonogramming) {
            console.log('ugc update done', uploadedImageDetails);
          }
        },
        setValue: true
      }, function (err) {
        if (err) {
          console.log('ugc error', err);
        }

        app.performance.mark('configure:ugc:success-callback');
      });
    }
  }

  // Defer updating text to avoid race condition with image updates
  let updateTextTimeout;

  const deferNonClothingUpdateText = (change) => {
    app.performance.mark('configure:ugc:start');

    const alias = change.ca.alias;
    const options = app.helpers.getSelectedValueByAlias('names_and_monograms');
    const md = app.utils.getMetaData(options);
    const uvMapType = md.uvmap;

    // Show/Hide the correct UV Map example
    if (app.isFluidEnv()) {
      if (uvMapType === 'standard') {
        $monogramCanvas.hide();
        $standardCanvas.show();
      } else {
        $monogramCanvas.show();
        $standardCanvas.hide();
      }
    }

    // If the font/color is clicked then we need to see if the monogram
    // supports multiple lines of text
    if (
      alias.indexOf('_customization_selection') >= 0 ||
      alias.indexOf('_monogram_embroidery_color') >= 0
    ) {
      const numLines = _.parseInt(md.numlines);

      // If the monogram supports more than one line of text then we want
      // to pass the data to our render method per line so both update
      if (numLines > 1) {
        _.times(numLines, (num) => {
          const line = num + 1;
          const parent = stripString(alias, ['_customization_selection', '_monogram_embroidery_color']);
          const _change = {
            ca: { alias: `${parent}_monogram_line_${line}` }
          };

          updateNonClothingText(_change, uvMapType);
        });
      } else {
        updateNonClothingText(change, uvMapType);
      }
    } else {
      updateNonClothingText(change, uvMapType);
    }
  };

  const deferUpdateText = (changes) => {
    if (updateTextTimeout) {
      clearTimeout(updateTextTimeout);
    }
    updateTextTimeout = setTimeout(() => updateText(changes), 15);
  };

  function verifyNonClothingChangesAreAllowed(changes) {
    const filteredChanges = changes.filter(o => {
      return allowedNonProductAlias.indexOf(o.ca.alias) !== -1;
    });
    if (!filteredChanges.length) {
      return;
    }
    filteredChanges.forEach(filteredChange => deferNonClothingUpdateText(filteredChange));
  }

  function getFacetId(facets, fvId) {
    let data = '';

    _.forEach(facets, (facet, facetId) => {
      if (facet.indexOf(fvId) >= 0) {
        data = _.parseInt(facetId);
      }
    });

    return data;
  }

  function handleNonClothingParentSelection(changes) {
    if (app.appUtils.isNonClothingProduct()) {
      changes.filter(o => {
        if (o.ca.alias === 'names_and_monograms') {
          const alias = 'parent_customization_selection';
          const selected = app.helpers.getSelectedValueByAlias(alias);
          const facets = app.helpers.getFacetsByAlias(alias);
          const fvId = facets.ct_customization.id;
          const facetId = getFacetId(selected.facets, fvId);

          configure.run('selectFacetValue', {
            caId: configure.run('getAttribute', { alias: 'oms_ct1' }).id,
            facetId,
            fvId
          });
        }
      });
    }
  }

  function verifyChangesAreAllowed(changes) {
    // Check to see if our allowed alias is defined
    const filteredChanges = changes.filter(o => {
      return allowedAlias.indexOf(o.ca.alias) !== -1;
    });
    if (!filteredChanges.length) {
      return;
    }
    filteredChanges.forEach(filteredChange => deferUpdateText(filteredChange));
  }

  const PIXEL_RATIO = (function () {
    const ctx = document.createElement('canvas').getContext('2d'),
      dpr = window.devicePixelRatio || 1,
      bsr = ctx.webkitBackingStorePixelRatio ||
        ctx.mozBackingStorePixelRatio ||
        ctx.msBackingStorePixelRatio ||
        ctx.oBackingStorePixelRatio ||
        ctx.backingStorePixelRatio || 1;

    return dpr / bsr;
  })();

  const canvasId = 'fc-canvas';
  const standardCanvasId = 'fc-standard-canvas';

  function createHiDPICanvas(w, h, id, ratio) {
    if (!ratio) { ratio = PIXEL_RATIO; }
    const can = document.createElement('canvas');
    can.id = id;
    can.width = w * ratio;
    can.height = h * ratio;
    can.style.width = w + 'px';
    can.style.height = h + 'px';
    if (!showRuler) {
      can.style.border = '1px solid';
    }
    can.getContext('2d').setTransform(ratio, 0, 0, ratio, 0, 0);
    return can;
  }

  const deferVerifyChanges = (changes) => {
    setTimeout(() => verifyChangesAreAllowed(changes), 300);
  };

  function init() {
    const families = [
      fonts.decoLeft,
      fonts.decoMiddle,
      fonts.decoRigth,
      fonts.ORL,
      fonts.SCR,
      fonts.CLA,
      fonts.GOT
    ];
    WebFont.load({
      custom: {
        families
      },
      async: true
    });

    if (document.getElementById(canvasId)) {
      document.getElementById(canvasId).remove();
    }

    if (document.getElementById(standardCanvasId)) {
      document.getElementById(standardCanvasId).remove();
    }

    $monogramCanvas = $(createHiDPICanvas(uvMap.width, uvMap.height, canvasId));
    $standardCanvas = $(createHiDPICanvas(nonMonogramUvMap.width, nonMonogramUvMap.height, standardCanvasId));

    if (app.isFluidEnv() && showMonogramming) {
      $monogramCanvas.appendTo('body');
      $standardCanvas.appendTo('body').hide();
    }

    configure.on('recipe:change', function (changes) {
      if (app.appUtils.isNonClothingProduct()) {
        verifyNonClothingChangesAreAllowed(changes);
        handleNonClothingParentSelection(changes);
      } else {
        if (app.appUtils.isSimpleCYO()) {
          SimpleCYO.verifyChanges(changes, $monogramCanvas);
        }

        verifyChangesAreAllowed(changes);
      }
    });

    configure.on('recipe:loaded', deferVerifyChanges);
  }

  /**
   *  Expose Public Properties/Methods
   */
  return {
    init,
    toggleDisplayLoading,
    baseAlias: SimpleCYO.baseAlias
  };
};

module.exports = Monogram;
